/* eslint-disable monorepo-cop/no-relative-import-outside-package */
import { heap } from '@/lib/utils'
import { UserMenu as BaseUserMenu, UserProfileImageDrawer } from '@eigtech/ui-shared-auth-web'
import {
  ButtonProps,
  MenuItem,
  forwardRef,
  useCopyToClipboard,
  useDisclosure,
} from '@eigtech/ui-shared-dave'
import { Sentry } from '@eigtech/ui-shared-sentry'
import { useState } from 'react'
import { MdContentCopy, MdEditSquare, MdPhone, MdUploadFile } from 'react-icons/md'
import { version as cinnamonVersion } from '../../../../eig/package.json'
import { version as uiVersion } from '../../../package.json'
import { EstimatorLicenseDrawer } from '../Core'
import { UserSmsModal } from '../Domains/Sms/UserSmsModal'
import { useGetUserSmsConnection } from '../../api/user/smsUser'

export type UserMenuProps = { isCollapsed: boolean } & ButtonProps

export const UserMenu = forwardRef<UserMenuProps, 'button'>((props, ref) => {
  const { copyToClipboard } = useCopyToClipboard()

  const userProfileImageDrawer = useDisclosure()
  const [isOpenAddPhoneNumberForSmsLogin, setIsOpenAddPhoneNumberForSmsLogin] = useState(false)
  const {
    isOpen: isOpenEstimatorLicenseDrawer,
    onOpen: onOpenEstimatorLicenseDrawer,
    onClose: onCloseEstimatorLicenseDrawer,
  } = useDisclosure()

  const { data: smsConnection, isPending: isPendingSmsConnection } = useGetUserSmsConnection()

  function logoutHook() {
    heap.resetIdentity()

    Sentry.setUser(null)
  }

  return (
    <>
      <BaseUserMenu
        ref={ref}
        {...props}
        beforeLogout={logoutHook}
        menuItems={[
          <MenuItem
            key="estimatorLicense"
            icon={<MdEditSquare />}
            onClick={onOpenEstimatorLicenseDrawer}
          >
            Update License Number
          </MenuItem>,
          <MenuItem
            key="userProfileImage"
            icon={<MdUploadFile />}
            onClick={userProfileImageDrawer.onOpen}
          >
            Update Profile Image
          </MenuItem>,
          <MenuItem
            key="addPhoneNumberForSmsLogin"
            icon={<MdPhone />}
            isDisabled={isPendingSmsConnection}
            onClick={() => setIsOpenAddPhoneNumberForSmsLogin(true)}
          >
            Add phone number for SMS login (optional)
          </MenuItem>,
          <MenuItem
            key="uiVersion"
            icon={<MdContentCopy />}
            onClick={() => copyToClipboard(uiVersion)}
          >
            UI v{uiVersion}
          </MenuItem>,
          <MenuItem
            key="cinnamonVersion"
            icon={<MdContentCopy />}
            onClick={() => copyToClipboard(cinnamonVersion)}
          >
            Cinnamon v{cinnamonVersion}
          </MenuItem>,
        ]}
      />
      {userProfileImageDrawer.isOpen && <UserProfileImageDrawer {...userProfileImageDrawer} />}
      <UserSmsModal
        open={isOpenAddPhoneNumberForSmsLogin}
        phoneNumber={smsConnection?.phoneNumber}
        onOpenChange={setIsOpenAddPhoneNumberForSmsLogin}
      />
      {isOpenEstimatorLicenseDrawer && (
        <EstimatorLicenseDrawer isOpen onClose={onCloseEstimatorLicenseDrawer} />
      )}
    </>
  )
})
